/**
 * A keybook key whose OWNER deleted their Papan account keeps the owner's email
 * as the org's record, prefixed so it can never match a member's email again:
 * the owner floor ("the owner always manages their key") must not pass to
 * whoever later holds the same address (an org re-issuing alice@acme.com).
 * The key shows as orphaned; a manager claims it, or transfers it back to the
 * address once it is a member again. Written by account erasure.
 */
export const ERASED_OWNER_PREFIX = 'deleted:'

/** The former owner's email when `ownerId` is an erased owner, else null. */
export function erasedOwnerEmail(ownerId: string): string | null {
  return ownerId.startsWith(ERASED_OWNER_PREFIX) ? ownerId.slice(ERASED_OWNER_PREFIX.length) : null
}
